import { render, staticRenderFns } from "./orgDialog.vue?vue&type=template&id=9e56c9de&scoped=true"
import script from "./orgDialog.vue?vue&type=script&lang=js"
export * from "./orgDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e56c9de",
  null
  
)

export default component.exports